import { PlaidRequest } from '@core/classes/Plaid/PlaidRequest';
import request from '@core/services/request';

export const plaidAPI = {
	findExistingCustomer: (customerId: any) => request.get(`/Plaid/FindExistingCustomer/${customerId}`),
	getPastPlaidExchanges: (customerAssociations: any, interactionFilter = -1) =>
		request.post(`/Plaid/GetPastPlaidExchanges`, {
			customerAssociations,
			interactionFilter,
		}),
	getNewestPlaidExchanges: (customerAssociations: any, interactionFilter: any) =>
		request.post(`/Plaid/GetNewestPlaidExchanges`, {
			customerAssociations,
			interactionFilter,
		}),
	updateAccessToken: (customerId: any, plaidItemId: any) => request.post(`/Plaid/UpdateAccessToken`, { customerId, plaidItemId }),

	createLinkToken: (linkTokenOptions: any) => request.post(`/Plaid/CreateLinkToken`, linkTokenOptions),
	getLinkToken: (linkToken: any) => request.get(`/Plaid/GetLinkToken?linkToken=${linkToken}`),
	accessTokenExchange: (publicToken: any, customerId: any, customerIdType: any, storeCode: any) =>
		request.post(`/Plaid/AccessTokenExchange`, {
			publicToken,
			customerId,
			customerIdType,
			storeCode,
		}),
	accessTokenExchangeCreditSession: (customerId: any, storeCode: any) =>
		request.post(`/Plaid/AccessTokenExchange/CreditSession`, PlaidRequest.create(true, { customerId, storeCode })),
	getItem: (customerId: any, plaidItemId: any) => request.get(`/Plaid/GetItem/${customerId}/${plaidItemId}`),
	deleteItem: (customerId: any, plaidItemId: any) => request.post(`/Plaid/DeleteItem`, { customerId, plaidItemId }),
	storeLinkSession: (accountLinked: any, linkSession: any, storeCode: any = null, associations: any = []) =>
		request.post(`/Plaid/StoreLinkSession`, PlaidRequest.create({ request: accountLinked, response: linkSession }, { associations, storeCode })),
	getPlaidPortalLink: (generateLinkRequest: any) => request.post(`/Plaid/Portal/GetLink`, generateLinkRequest),
	sendLinkToPortal: (generateLinkRequest: any) => request.post(`/Plaid/Portal/SendLink`, generateLinkRequest),
	sendAccessCodeToPortal: (generateLinkRequest: any) => request.post(`/Plaid/Portal/SendAccessCode`, generateLinkRequest),
	getAvailableIncomeData: (customerId: any, storeCode: any = null, associations: any = []) =>
		request.post(`/Plaid/Portal/GetIncomeData`, PlaidRequest.create(true, { customerId, storeCode, associations })),

	createIdentityVerification: (templateId: any, userInfo: any, storeCode: any = null, associations: any = []) =>
		request.post(`/Plaid/CreateIdentityVerification`, PlaidRequest.create({ templateId, userInfo }, { associations, storeCode })),
	getIdentityVerification: (identityVerificationId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetIdentityVerification`, PlaidRequest.create({ identityVerificationId: identityVerificationId }, { associations, storeCode })),
	getIdentityVerificationList: (customerId: any, templateId = '') =>
		request.post(`/Plaid/GetIdentityVerificationList`, PlaidRequest.create({ clientUserId: customerId, templateId })),
	quickIDVRecheck: (templateId: any, clientUserId: any, userData: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/QuickIDVRecheck`, PlaidRequest.create({ templateId, clientUserId, user: userData }, { associations, storeCode })),
	retryIdentityVerification: (templateId: any, clientUserId: any, userData: any = null, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/RetryIdentityVerification`, PlaidRequest.create({ templateId, clientUserId, user: userData }, { associations, storeCode })),
	getMostRecentIDVSessionID: (customerId: any, associationType: any) =>
		request.get(`/Plaid/GetMostRecentIDVSessionID?associationType=${associationType}&associationId=${customerId}`),
	getNewestIdentityVerification: (customerId: any, associations: any = []) =>
		request.post(`/Plaid/GetIdentityVerification/Newest`, PlaidRequest.create(true, { associations, customerId })),

	getMonitorIndividualScreening: (watchlistScreeningId: any, storeCode: any = null, associations: any = []) =>
		request.post(`/Plaid/MonitorIndividual/GetScreening`, PlaidRequest.create({ watchlistScreeningId }, { associations, storeCode })),
	getAllMonitorIndividualHits: (screeningId: any) => request.get(`/Plaid/MonitorIndividual/GetAllHits?watchlistScreeningId=${screeningId}`),

	getBankIdentity: (customerId: any, plaidItemId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(
			`/Plaid/GetIdentity`,
			PlaidRequest.create(null, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),

	getAccounts: (customerId: any, plaidItemId: any) => request.get(`/Plaid/GetAccounts/${customerId}/${plaidItemId}`),
	getAccountsBalance: (customerId: any, plaidItemId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(
			`/Plaid/GetAccountsBalance`,
			PlaidRequest.create(null, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),

	createIncomeUser: (customerId: any, customerIdType: any, storeCode: any) =>
		request.post(`/Plaid/CreateIncomeUser`, {
			customerId,
			customerIdType,
			storeCode,
		}),
	getIncomeSessions: (customerId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetIncomeSessions`, PlaidRequest.create(true, { associations, storeCode, customerId })),
	getBankIncome: (customerId: any, count: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetBankIncome`, PlaidRequest.create({ options: { count } }, { associations, storeCode, customerId })),
	downloadBankIncome: (customerId: any, storeCode?: any) =>
		request.downloadPost(`/Plaid/GetBankIncome/PDF`, PlaidRequest.create(null, { customerId, storeCode }), 'plaid_bank_income.pdf'),
	getAllBankIncome: (customerId: any) => request.post(`/Plaid/GetAllBankIncomeReports`, PlaidRequest.create(true, { customerId })),
	refreshBankIncome: (requestObj: any, customerId: any, storeCode: any, associations: any) =>
		request.post(
			`/Plaid/RefreshBankIncome`,
			PlaidRequest.create(requestObj, {
				associations,
				customerId,
				storeCode,
			}),
		),
	saveAllBankIncomeData: (customerId: any, storeCode: any, associations: any) =>
		request.post(`/Plaid/SaveAllBankIncomeData`, PlaidRequest.create(true, { customerId, storeCode, associations })),
	getPayrollIncome: (customerId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetPayrollIncome`, PlaidRequest.create(true, { associations, storeCode, customerId })),
	getPayrollRiskSignals: (customerId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetPayrollRiskSignals`, PlaidRequest.create(true, { associations, storeCode, customerId })),
	downloadPayrollDocument: (customerId: any, payrollItemId: any, documentId: any) =>
		request.download(`/Plaid/DownloadPayrollDocument?customerId=${customerId}&itemId=${payrollItemId}&documentId=${documentId}`, 'plaid_payroll_document.zip'),

	createAssetReport: (customerId: any, plaidItemIds: any, createRequest: any, storeCode: any = null, associations: any[] = []) =>
		request.post(
			`/Plaid/CreateAssetReport`,
			PlaidRequest.create(createRequest, {
				associations,
				storeCode,
				customerId,
				plaidItemIds,
			}),
		),
	getAssetReport: (customerId: any, getRequest: any, storeCode: any = null, associations: any = []) =>
		request.post(
			`/Plaid/GetAssetReport`,
			PlaidRequest.create(getRequest, {
				associations,
				storeCode,
				customerId,
			}),
		),
	refreshAssetReport: (customerId: any, refreshRequest: any, storeCode: any = null, associations: any = []) =>
		request.post(
			`/Plaid/RefreshAssetReport`,
			PlaidRequest.create(refreshRequest, {
				associations,
				storeCode,
				customerId,
			}),
		),
	removeAssetReport: (customerId: any, assetReportId: any, storeCode: any = null, associations: any = []) =>
		request.post(`/Plaid/RemoveAssetReport`, PlaidRequest.create({ assetReportToken: assetReportId }, { associations, storeCode, customerId })),

	getBankStatementList: (customerId: any, plaidItemId: any, storeCode: any = null, associations: any = []) =>
		request.post(
			`/Plaid/GetBankStatementsList`,
			PlaidRequest.create(true, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),
	saveBankStatement: (customerId: any, plaidItemId: any, statementId: any, storeCode: any, associations: any) =>
		request.post(`/Plaid/SaveBankStatement`, PlaidRequest.create({ statementId }, { associations, storeCode, customerId, plaidItemIds: [plaidItemId] })),
	saveAllBankStatements: (customerId: any, plaidItemId: any, storeCode: any, associations: any) =>
		request.post(
			`/Plaid/SaveAllBankStatements`,
			PlaidRequest.create(true, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),
	downloadBankStatement: (customerId: any, plaidItemId: any, statementId: any, fileName = 'bankStatement.pdf') =>
		request.downloadPost(`/Plaid/DownloadBankStatement`, PlaidRequest.create({ statementId }, { customerId, plaidItemIds: [plaidItemId] }), fileName),

	createTransferIntent: (transferIntent: any) => request.post(`/Plaid/CreateTransferIntent`, transferIntent),
	getTransferIntent: (transferIntentId: any) => request.get(`/Plaid/GetTransferIntent/${transferIntentId}`),
	createTransferAuthorization: (customerId: any, plaidItemId: any, transferAuthRequest: any, storeCode: any = null, associations: any[] = []) =>
		request.post(
			`/Plaid/CreateTransferAuthorization`,
			PlaidRequest.create(transferAuthRequest, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),
	createTransfer: (customerId: any, plaidItemId: any, transferRequest: any, storeCode: any = null, associations: any[] = []) =>
		request.post(
			`/Plaid/CreateTransfer`,
			PlaidRequest.create(transferRequest, {
				associations,
				storeCode,
				customerId,
				plaidItemIds: [plaidItemId],
			}),
		),
	getTransfer: (transferId: any, storeCode: any = null, associations: any[] = []) =>
		request.post(`/Plaid/GetTransfer`, PlaidRequest.create({ transferId }, { associations, storeCode })),
};
